!function($, window, document) {
    const $html = $("html"), $win = $(window), $doc = $(document), $body = $(document.body), $header = $(".header");
    function window_width() {
        return $win.width();
    }
    function window_height() {
        return window.innerHeight;
    }
    function is_desktop() {
        return window_width() > 1023;
    }
    function getSubmenuHeight() {
        return is_desktop() && $html.css("--submenu-height") ? Math.floor($html.css("--submenu-height").slice(0, -2)) - 2 : -2;
    }
    function setCSSVariable(name, value, unit = "", $element = $html) {
        $element.css(`--${name}`, `${value}${unit}`);
    }
    function isTouchDevice() {
        return "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
    }
    $.event.special.widthResize = {
        setup: function() {
            const $this = $(this);
            $this.data("currentWidth", $this.width()), $this.on("resize.widthResize", (function() {
                const newWidth = $this.width();
                newWidth !== $this.data("currentWidth") && $this.data("currentWidth", newWidth).trigger("widthResize");
            }));
        },
        teardown: function() {
            $(this).off("resize.widthResize");
        }
    };
    const fadeUpObserver = new IntersectionObserver(((entries, observer) => {
        entries.forEach((entry => {
            entry.isIntersecting && ($(entry.target).addClass("is-visible"), observer.unobserve(entry.target));
        }));
    }), {
        threshold: .1
    });
    let popupTimeout;
    function checkScheduleStatus() {
        const AESTTime = moment.tz("Australia/Sydney"), currentHour = AESTTime.hour(), currentMinute = AESTTime.minute(), currentDay = AESTTime.day(), isWeekday = currentDay >= 1 && currentDay <= 5, isWithinHours = (currentHour > 8 || 8 === currentHour && currentMinute >= 30) && currentHour < 17;
        $(".js-schedule").length > 0 && $(".js-schedule").each((function() {
            $(this).toggleClass("inactive", !(isWeekday && isWithinHours));
        }));
    }
    function getDistanceFromRightOfWindow($element) {
        if ($element.length < 1) return 0;
        const rect = $element.get(0).getBoundingClientRect();
        return window.innerWidth - rect.left;
    }
    function getLeftOffset($element) {
        return $element.length < 1 ? 0 : $element.offset().left;
    }
    function activeMenuItem() {
        const $currentMenuItem = $(".current-menu-item");
        if (!$currentMenuItem.length > 0) return;
        setCSSVariable("active-line-width", getDistanceFromRightOfWindow($currentMenuItem.is("a") ? $currentMenuItem.find("svg") : $currentMenuItem.find("> a")), "px");
    }
    $(".js-fade-up").each((function() {
        fadeUpObserver.observe(this);
    })), $(".js-popup-open").on("click", (function(e) {
        e.preventDefault();
        const $targetPopup = $($(this).attr("href"));
        $targetPopup.attr("id").startsWith("popup-gallery") && ($body.addClass("popup-open"), 
        $(".popup").removeClass("is-open is-done-animation"), $targetPopup.addClass("is-open")), 
        $targetPopup.hasClass("popup--below") && (clearTimeout(popupTimeout), popupTimeout = setTimeout((() => {
            $targetPopup.addClass("is-done-animation"), setTimeout((() => {
                const lottie = $targetPopup.find(".js-lottie").data("lottie");
                lottie && lottie.play();
            }), 200);
        }), 600));
    })), $(".js-popup-close").on("click", (function(e) {
        e.preventDefault(), clearTimeout(popupTimeout), $body.removeClass("popup-open");
        const $currentPopup = $(this).closest(".js-popup");
        $(".js-popup").each((function() {
            const lottie = $(this).find(".js-lottie").data("lottie");
            lottie && lottie.goToAndStop(0, !0);
        })), $currentPopup.removeClass("is-open is-done-animation"), $currentPopup.find(".component-media").each((function() {
            const plyr = $(this)[0].plyr;
            plyr && plyr.pause();
        }));
    })), $doc.on("mouseup", (function(e) {
        const $container = $(".popup__inner > *");
        $container.is(e.target) || 0 !== $container.has(e.target).length || (clearTimeout(popupTimeout), 
        $body.removeClass("popup-open"), $(".js-popup").removeClass("is-open is-done-animation"), 
        $(".js-popup").each((function() {
            const lottie = $(this).find(".js-lottie").data("lottie");
            lottie && lottie.goToAndStop(0, !0);
        })), $(".js-popup").find(".component-media").each((function() {
            const plyr = $(this)[0].plyr;
            plyr && plyr.pause();
        })));
    })), checkScheduleStatus(), setInterval(checkScheduleStatus, 6e4), setCSSVariable("dvh", .01 * window_height(), "px"), 
    setCSSVariable("current-dvh", .01 * window_height(), "px"), setCSSVariable("footer-height", $(".footer").outerHeight(), "px"), 
    setCSSVariable("bar-height", $(".bar").outerHeight(), "px"), setCSSVariable("header-height", $(".header").outerHeight(), "px"), 
    setCSSVariable("logo-offset", getDistanceFromRightOfWindow($(".header__logo-secondary svg")), "px"), 
    setCSSVariable("offset-width", getLeftOffset($(".slider-features")), "px"), setCSSVariable("container-offset", getLeftOffset($("section .shell")), "px"), 
    $body.toggleClass("is-touch-device", isTouchDevice()), $win.on("resize scroll", (function() {
        setCSSVariable("current-dvh", .01 * window_height(), "px"), setCSSVariable("footer-height", $(".footer").outerHeight(), "px"), 
        setCSSVariable("bar-height", $(".bar").outerHeight(), "px"), setCSSVariable("header-height", $(".header").outerHeight(), "px"), 
        setCSSVariable("logo-offset", getDistanceFromRightOfWindow($(".header__logo-secondary svg")), "px"), 
        $body.toggleClass("is-touch-device", isTouchDevice());
    })), $win.on("widthResize", (function() {
        setCSSVariable("dvh", .01 * window_height(), "px"), setCSSVariable("offset-width", getLeftOffset($(".slider-features")), "px"), 
        setCSSVariable("container-offset", getLeftOffset($("section .shell")), "px"), activeMenuItem();
    })), $(".nav > ul > li, .header__logo-secondary").on("mouseenter", (function(e) {
        const $this = $(this), $submenu = $this.find("ul"), $target = $this.is("a") ? $this.find("svg") : $this.find("> a");
        $this.is("li") && $header.removeClass("is-secondary-logo-hovered"), setCSSVariable("active-line-width", getDistanceFromRightOfWindow($target), "px"), 
        $submenu.length && window.outerWidth >= 1023 ? setCSSVariable("submenu-height", $submenu.outerHeight(), "px") : setCSSVariable("submenu-height", 0, "px");
    })).on("mouseleave", (function(e) {
        $(".header__logo-secondary.current-menu-item").length > 0 && $header.addClass("is-secondary-logo-hovered"), 
        setCSSVariable("submenu-height", 0, "px"), setCSSVariable("active-line-width", "", ""), 
        activeMenuItem();
    })), activeMenuItem(), $(".js-scroll").on("click", (function(e) {
        const href = $(this).attr("href");
        if (!href || !href.startsWith("#")) return !0;
        {
            e.preventDefault();
            const $target = $(href);
            $("html, body").animate({
                scrollTop: $target.offset().top - $(".header").outerHeight() - $(".bar").outerHeight() - 50
            }, 1e3);
        }
    })), $(".nav-btn").on("click", (function(e) {
        e.preventDefault(), $body.toggleClass("menu-open"), $(this).text($body.hasClass("menu-open") ? "Close" : "Menu");
    })), $(".nav li:has(ul)").on("click", (function(e) {
        if (!$(e.target).is("a") && function is_tablet() {
            return window_width() <= 1023;
        }()) {
            e.preventDefault();
            const $this = $(this);
            $this.toggleClass("is-active").siblings().removeClass("is-active"), $this.siblings().find("ul").stop().slideUp();
            $this.find("ul").stop().slideToggle(), $this.hasClass("is-active") ? $this.siblings().addClass("is-inactive") : $this.siblings().removeClass("is-inactive");
        }
    })), $(".js-floorplan-expand .floorplan__outer").slideUp(), $(".js-floorplan-expand > .floorplan__inner").on("click", (function() {
        $(this).parent().toggleClass("is-active"), $(this).siblings(".floorplan__outer").slideToggle();
    }));
    $(".js-floorplans-image img").attr("src");
    $(".js-floorplan-building").each((function() {
        const $this = $(this), index = $this.index();
        $this.on("mouseover", (function() {
            $(".js-floorplans-image img").eq(index).addClass("is-visible");
        })), $this.on("mouseleave", (function() {
            $(".js-floorplans-image .is-visible").removeClass("is-visible");
        }));
    })), $(".js-accordion .accordion__head").on("click", (function() {
        const $this = $(this), $target = $this.siblings(".accordion__body");
        $this.closest(".hero-location").length > 0 && is_desktop() || ($this.parent(".accordion__section").toggleClass("is-active").siblings().removeClass("is-active"), 
        $target.slideToggle().parent(".accordion__section").siblings().find(".accordion__body").stop().slideUp());
    })), $win.on("widthResize", (function(e) {
        is_desktop() && $(".hero-location").find(".accordion__section.is-active").removeClass("is-active");
    }));
    const $pinright = $(".js-pin").css("right"), $pinTop = $(".js-pin").css("top");
    function heroAerialHeight() {
        const $heroAerialImgHeight = $(".hero-location").find(".hero__background img").height();
        $(window).width() > 1023 ? $(".hero-location .hero__content").css("height", $heroAerialImgHeight) : $(".hero-location .hero__content").css("height", "auto");
    }
    $(".js-pin-position").each((function() {
        const $this = $(this), $targetX = $this.data("x"), $targetY = $this.data("y");
        $this.on("mouseenter", (function() {
            $this.addClass("is-active"), $(".js-pin").css({
                right: $targetX,
                top: $targetY
            }), 0 == is_desktop() && $(".js-pin").css({
                right: $targetX,
                top: $targetY
            });
        })), $this.on("mouseleave", (function() {
            $this.removeClass("is-active"), is_desktop() && $(".js-pin").css({
                right: $pinright,
                top: $pinTop
            });
        })), $win.on("widthResize", (function() {
            is_desktop() && $(".js-pin").css({
                right: $pinright,
                top: $pinTop
            });
        }));
    })), $(".js-pin").on("mouseover", (function() {
        $(this).addClass("is-active");
    })), function sliderGalleryInit() {
        $(".js-slider-gallery").each((function() {
            const $this = $(this), $slidesGallery = $this.find(".slider__slides").eq(0), $sliderPrev = $this.find(".slider__prev"), $sliderNext = $this.find(".slider__next");
            if ($slidesGallery.length && $slidesGallery.find(".slider__slide").length >= 1 && !$slidesGallery.hasClass("slick-initialized")) {
                $slidesGallery.slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: !0,
                    autoplay: !1,
                    fade: !0,
                    dots: !1,
                    arrows: !1,
                    centerMode: !1
                });
                new IntersectionObserver((entries => {
                    entries.forEach((entry => {
                        entry.isIntersecting ? $slidesGallery.slick("slickPlay") : $slidesGallery.slick("slickPause");
                    }));
                }), {
                    threshold: .5
                }).observe($slidesGallery[0]);
            }
            $sliderPrev.on("click", (function(e) {
                e.preventDefault(), $slidesGallery.slick("slickPrev");
            })), $sliderNext.on("click", (function(e) {
                e.preventDefault(), $slidesGallery.slick("slickNext");
            })), $slidesGallery.find(".slider__slide").length <= 1 && ($sliderPrev.hide(), $sliderNext.hide());
        }));
    }(), $('.sub-menu a[href*="#"]').on("click", (function(event) {
        const locationPath = location.pathname.replace(/^\//, ""), locationHost = location.hostname;
        if (locationPath === this.pathname.replace(/^\//, "") && locationHost === this.hostname) {
            event.preventDefault();
            const $menuItem = $(this).parent(".menu-item"), $siblings = $menuItem.siblings();
            $menuItem.toggleClass("is-active"), $siblings.removeClass("is-active");
            let target = $(this.hash);
            target = target.length ? target : $(`[name='${this.hash.slice(1)}']`);
            const dataColor = target.data("color");
            dataColor ? ($menuItem.css("color", dataColor), $header.addClass("is-dark")) : ($siblings.css("color", "#fff"), 
            $header.removeClass("is-dark"));
            const $parentMenuItem = $(this).closest(".sub-menu").siblings("a");
            if ($parentMenuItem.length) {
                const parentHref = $parentMenuItem.attr("href"), currentHref = window.location.href;
                if (target.length) {
                    const isFadeUp = target.is(".js-fade-up:not(.is-visible)") ? 50 : 0;
                    let scrollTargetPosition = target.offset().top - $(".header").outerHeight() - $(".bar").outerHeight() - getSubmenuHeight() - isFadeUp;
                    $("html, body").animate({
                        scrollTop: scrollTargetPosition
                    }, {
                        duration: 500,
                        step: function(now, fx) {
                            "scrollTop" === fx.prop && (fx.end = scrollTargetPosition);
                        },
                        done: function() {
                            clearInterval(scrollTargetInterval);
                        }
                    });
                    const scrollTargetInterval = setInterval((() => {
                        scrollTargetPosition = target.offset().top - $(".header").outerHeight() - $(".bar").outerHeight() - getSubmenuHeight() - isFadeUp;
                    }), 10);
                    $("body").hasClass("menu-open") && ($("body").removeClass("menu-open"), $(".menu-item").removeClass("is-active"), 
                    $(".menu-item").removeClass("is-inactive"), $(".menu-item a").removeClass("menu-opened"), 
                    $(".sub-menu").slideUp("is-active"), $(".nav-btn").text("Menu"));
                } else if (parentHref && parentHref !== currentHref) return sessionStorage.setItem("scrollToHash", this.hash), 
                void (location.href = parentHref);
            }
            if (target.length && target.hasClass("tab")) {
                target.addClass("is-active").siblings().removeClass("is-active");
                $(".js-tabs .tabs__nav a").each((function() {
                    target.attr("id") === $(this).attr("href").replace("#", "") && $(this).parent("li").addClass("is-active").siblings().removeClass("is-active");
                })), $(".js-slider-objects .slider__slides").slick("setPosition");
            } else sessionStorage.setItem("scrollToHash", this.hash);
        }
        console.timeEnd("Menu Click Execution Time");
    })), $('.sub-menu a[href*="#"]').on("mouseenter", (function(event) {
        $(this).parent().hasClass("is-diff-color") ? $(".header").addClass("is-dark") : $(".header").removeClass("is-dark");
    })), $('.sub-menu a[href*="#"]').on("mouseleave", (function(event) {
        $(".header").removeClass("is-dark");
    })), $(".js-lightbox-gallery").magnificPopup({
        delegate: ".js-lightbox-link",
        type: "image",
        tLoading: "Loading image #%curr%...",
        mainClass: "mfp-img-mobile",
        fixedContentPos: !0,
        overflowY: "hidden",
        gallery: {
            enabled: !0,
            navigateByImgClick: !0,
            preload: [ 0, 1 ]
        },
        image: {
            tError: '<a href="%url%">The image #%curr%</a> could not be loaded.'
        }
    }), AOS.init(), function duplicateHeroBackgroundImage() {
        $(".hero-location .hero__background img").clone().appendTo(".hero-location .hero__background-outer");
    }(), heroAerialHeight(), $(window).on("resize", (function() {
        heroAerialHeight();
    })), setTimeout((() => {
        var scrollToHash = sessionStorage.getItem("scrollToHash");
        sessionStorage.getItem("activeLinkSelector"), sessionStorage.getItem("activeLink");
        if (scrollToHash) {
            var target = $(scrollToHash), dataColor = target.data("color");
            if ($('.sub-menu a[href*="#"]').each((function() {
                target.attr("id") == $(this).attr("href").replace("#", "") && ($(this).parent(".menu-item").addClass("is-active").siblings().removeClass("is-active"), 
                dataColor ? ($(this).parent().css("color", dataColor), $(".header").addClass("is-dark")) : ($(this).parent().siblings().css("color", "#fff"), 
                $(".header").removeClass("is-dark")));
            })), (target = target.length ? target : $("[name=" + scrollToHash.slice(1) + "]")).length) if (target.hasClass("tab")) target.addClass("is-active").siblings().removeClass("is-active"), 
            $(target).parent().siblings().find(".tabs__nav .is-active a").removeClass("is-active").siblings().addClass("is-active"), 
            $(".js-tabs .tabs__nav a").each((function() {
                target.attr("id") == $(this).attr("href").replace("#", "") && $(this).parent("li").addClass("is-active").siblings().removeClass("is-active");
            })), $("html, body").animate({
                scrollTop: target.offset().top
            }, 500); else {
                const isFadeUp = target.is(".js-fade-up:not(.is-visible)") ? 50 : 0;
                let scrollTargetPosition = target.offset().top - $(".header").outerHeight() - $(".bar").outerHeight() - getSubmenuHeight() - isFadeUp;
                $("html, body").animate({
                    scrollTop: scrollTargetPosition
                }, {
                    duration: 500
                });
            }
            sessionStorage.removeItem("scrollToHash"), sessionStorage.removeItem("activeLinkSelector"), 
            sessionStorage.removeItem("activeLink");
        }
    }), 150), $(".js-tabs .tabs__btn").on("click", (function(e) {
        e.preventDefault();
        const $this = $(this), $target = $this.attr("href");
        $this.parent().addClass("is-active").siblings().removeClass("is-active"), $($target).addClass("is-active").siblings().removeClass("is-active");
    }));
    const $heroInner = $(".hero-location .hero__inner");
    let pointerEventsTimeout;
    $heroInner.on("scroll", (function() {
        const scrollTop = $(this).scrollTop(), scrollHeight = $(this)[0].scrollHeight;
        scrollTop + $(this).outerHeight() >= scrollHeight - 1 && $(this).css("pointer-events", "none");
    })), $win.on("scroll", (function() {
        pointerEventsTimeout = setTimeout((function() {
            $heroInner.css("pointer-events", "auto");
        }), 1e3);
    }));
    const $secondaryLogo = $(".header__logo-secondary");
    $secondaryLogo.on("mouseenter", (function() {
        $header.addClass("is-secondary-logo-hovered");
    })).on("mouseleave", (function() {
        $secondaryLogo.hasClass("current-menu-item") || $header.removeClass("is-secondary-logo-hovered");
    }));
}(jQuery, window, document);